(function(){

/* ===================== TRANSLATIONS ===================== */
var translations = {
    it:{
    recipient:'Destinatario',
    story:'Storia',
    details:'Dettagli',

    song_price:'🎄Prezzo festivo',
    price_label:'Prezzo',
    delivery_label:'Consegna',
    total_label:'Totale',
    included:'Incluso',

    express_delivery:'Express (1 ora)',
    fast_delivery:'Veloce (3-5 ore)',
    standard_delivery:'Standard (10-12 ore)',

    choose_type:'Scegli che tipo di canzone personalizzata vuoi creare',

    // Etichette per le chip dei prodotti
    secret_santa:'Secret Santa',
    christmas_newyear:'Capodanno',
    year_2025:'Il tuo 2025',

    // Vecchie categorie generiche (se mai le riusi)
    love:'Amore',
    birthday:'Compleanno',
    family:'Famiglia',
    joke:'Scherzo',
    children:'Bambini',
    freestyle:'Idea Libera',

    choose_language:'Scegli la lingua della canzone',
    select_language:'Seleziona lingua',

    name_label:'Nome della persona',
    name_placeholder:"es. Anna, Luca, Mamma, Max (il nostro cane)",

    select_genre:'Seleziona genere',
    choose_mood:'Scegli un mood',
    select_mood:'Seleziona opzione',

        // Nuove label per i 3 prodotti speciali
    secret_santa_name_label: "Per chi è questa canzone Secret Santa?",
    secret_santa_name_placeholder: "es. La mia collega Sara, il mio amico John...",

    christmas_newyear_name_label: "Per chi è questa canzone di Capodanno?",
    christmas_newyear_name_placeholder: "es. La mia famiglia… Il mio partner Sarah… I miei figli… Il mio migliore amico… I miei colleghi...",

    year_2025_name_label: "Per chi è questa canzone 2025?",
    year_2025_name_placeholder: "es. Per me (il tuo nome)… Per il mio partner Sarah… Per la mia famiglia (nomi)…",

    // Label blocco Secret Santa (step 3)
    santa_visibility_label: "Visibilità del nome di Secret Santa",
    santa_name_label: "Nome del mittente (come deve apparire nella canzone)",

    // Testo dei due pulsanti Secret Santa
    keep_name_secret: "Tieni segreto il mio nome",
    reveal_my_name: "Rivela il mio nome",
    santa_name_placeholder: "es. Dal tuo Secret Santa, Emma",


    // Nuovo: “Scegli l’occasione”
    choose_occasion:"Scegli l'occasione",
    occasion:'Occasione',

    choose_style:'Scegli uno stile di canzone',
    select_style:'Seleziona stile',

    person_age:'Quanti anni compie la persona',

    story_label:'Qual è la storia o il messaggio che vuoi nella canzone?',

    // Placeholder di esempio per prodotti “classici” (li puoi ancora riusare)
    love_placeholder:"es. Come ci siamo conosciuti a Parigi",
    birthday_placeholder:"es. Maria",
    family_placeholder:"es. Mamma – Ana, Papà – Javier, Figli – Sofia e Matteo...",
    joke_placeholder:"es. Il mio amico Jorge, i miei colleghi, il mio capo, il Real Madrid",
    children_placeholder:"es. Emma, 2 anni",
    freestyle_placeholder:"es. Il mio cane che ruba la pizza",

    story_placeholder:'es. Come ci siamo incontrati a Parigi...',

    // Generi / stili
    'Surprise me':'Sorprendimi',
    'Birthday style':'Stile compleanno',
    'Pop-rock':'Pop-rock',
    'Pop':'Pop',
    'Rock':'Rock',
    'Jazz':'Jazz',
    'Blues':'Blues',
    'Hip-hop':'Hip-hop',
    'Folk':'Folk',
    'Rap':'Rap',
    'Soul':'Soul',
    'Country':'Country',
    'Electronic':'Electronic',
    'Reggae':'Reggae',

    // Nuovi stili di Natale / Capodanno
    'Christmas style':'Stile natalizio',
    'Christmas & New year style':'Stile Natale & Capodanno',

    // Mood / Occasioni
    Christmas:'Natale',
    'New Year':'Capodanno',
    'Christmas & New Year':'Natale & Capodanno',
    Happy:'Felice',

    Romantic:'Romantico',
    Emotional:'Emozionale',
    Funny:'Divertente',
    Nostalgic:'Nostalgico',
    Flirty:'Civettuolo',
    Epic:'Epico',
    Cute:'Carino',
    Playful:'Giocoso',
    Lullaby:'Ninna nanna',

    // Nuovi mood per le canzoni di Natale / 2025
    Chill:'Rilassato',
    Energetic:'Energico',
    'Warm & Sweet':'Caldo e dolce',
    Upbeat:'Allegro',

    more_details:"Dimmi di più (Facoltativo)",
    more_placeholder:'Puoi scrivere tutto ciò che vorresti includere...',

    preferred_vocal:'Voce preferita',
    male:'Maschio',
    female:'Femmina',
    'no_preference':'Nessuna preferenza',

    delivery_speed:'Velocità di consegna',
    select_delivery:'Seleziona tempo di consegna',

    back:'Indietro',
    next:'Avanti',
    checkout:'Procedi al Checkout',

    // Label “per chi è la canzone” per vecchi prodotti
    love_name:"Per chi è questa canzone d'amore?",
    birthday_name:'Qual è il nome o soprannome di questa persona:',
    family_name:'Quali membri della famiglia dovrebbero essere menzionati?',
    joke_name:'Di chi o di cosa dovrebbe parlare la canzone?',
    children_name:'Nome e età del bambino',
    freestyle_name:'Di cosa dovrebbe parlare la canzone?',

    birthday_story:'Cosa ama o apprezza questa persona? Abitudini divertenti, storie o battute interne?',
    family_story:'Ricordi speciali o tradizioni familiari?',
    joke_story:"Cosa gli piace fare o cosa fa di divertente?",
    children_story:'Cosa li fa sorridere',
    freestyle_story:'Qual è la storia o il messaggio che vuoi nella canzone?',

    children_more:'Dimmi di più sul bambino',
    other_more:'Dimmi di più (Facoltativo)',

    err_dedication:'Per favore scegli un\'opzione.',
    err_name:'Per favore inserisci un nome.',
    err_language:'Per favore seleziona una lingua.',
    err_genre:'Per favore seleziona un genere.',
    err_mood:'Per favore seleziona un mood.',
    err_style:'Per favore seleziona uno stile.',
    err_age:'Per favore inserisci un\'età.',
    err_story:'Per favore condividi qualche riga.',
    err_vocal:'Per favore scegli una preferenza vocale.',
    err_delivery:'Per favore seleziona una velocità di consegna.'
  },


    el:{
    recipient:'Παραλήπτης', story:'Ιστορία', details:'Λεπτομέρειες',

    song_price:'🎄Εορταστική τιμή',
    price_label:'Τιμή',
    delivery_label:'Παράδοση',
    total_label:'Σύνολο',
    included:'Περιλαμβάνεται',

    express_delivery:'Express (1 ώρα)',
    fast_delivery:'Γρήγορη (3–5 ώρες)',
    standard_delivery:'Κανονική (10–12 ώρες)',

    choose_type:'Επιλέξτε τι τύπο εξατομικευμένου τραγουδιού θέλετε να δημιουργήσετε',

    // Ετικέτες για τα 3 ειδικά προϊόντα (chips)
    secret_santa:'Secret Santa',
    christmas_newyear:'Πρωτοχρονιά',
    year_2025:'Το 2025 σου',

    // Παλαιότερες γενικές κατηγορίες (αν τις ξαναχρησιμοποιήσεις)
    love:'Αγάπη',
    birthday:'Γενέθλια',
    family:'Οικογένεια',
    joke:'Αστείο',
    children:'Παιδιά',
    freestyle:'Ανοιχτή Ιδέα',

    choose_language:'Επιλέξτε τη γλώσσα του τραγουδιού',
    select_language:'Επιλέξτε γλώσσα',

    name_label:'Όνομα του ατόμου',
    name_placeholder:'π.χ. Άννα, Λουκάς, Μαμά, Μαξ (ο σκύλος μας)',

    select_genre:'Επιλέξτε είδος',
    choose_mood:'Επιλέξτε διάθεση',
    select_mood:'Επιλέξτε επιλογή',

    // 🔴 ΝΕΕΣ label για τα 3 ειδικά προϊόντα (step 1)
    secret_santa_name_label: 'Για ποιον είναι αυτό το τραγούδι Secret Santa;',
    secret_santa_name_placeholder: 'π.χ. Η συνάδελφός μου Σάρα, ο φίλος μου Τζον...',

    christmas_newyear_name_label: 'Για ποιον είναι αυτό το τραγούδι Πρωτοχρονιάς;',
    christmas_newyear_name_placeholder: 'π.χ. Η οικογένειά μου… Ο/Η σύντροφός μου Σάρα… Τα παιδιά μου… Ο καλύτερός μου φίλος… Οι συνάδελφοί μου...',

    year_2025_name_label: 'Για ποιον είναι αυτό το τραγούδι 2025;',
    year_2025_name_placeholder: 'π.χ. Για μένα (το όνομά σου)… Για τον/την σύντροφό μου Σάρα… Για την οικογένειά μου (ονόματα)…',

    // Block Secret Santa (step 3)
    santa_visibility_label: 'Ορατότητα ονόματος Secret Santa',
    santa_name_label: 'Όνομα αποστολέα (όπως πρέπει να εμφανίζεται στο τραγούδι)',

    keep_name_secret: 'Κράτα το όνομά μου μυστικό',
    reveal_my_name: 'Αποκάλυψε το όνομά μου',
    santa_name_placeholder: 'π.χ. Από τον Secret Santa σου, Emma',

    // Νέο: «Επιλέξτε την περίσταση»
    choose_occasion:'Επιλέξτε την περίσταση',
    occasion:'Περίσταση',

    choose_style:'Επιλέξτε στυλ τραγουδιού',
    select_style:'Επιλέξτε στυλ',

    person_age:'Πόσο χρονών γίνεται το άτομο',

    story_label:'Ποια είναι η ιστορία ή το μήνυμα που θέλετε στο τραγούδι;',

    // per-product example placeholders (EL)
    love_placeholder:'π.χ. Πώς γνωριστήκαμε στο Παρίσι',
    birthday_placeholder:'π.χ. Μαρία',
    family_placeholder:'π.χ. Μαμά – Άννα, Μπαμπάς – Χαβιέ, Παιδιά – Σοφία και Ματέο...',
    joke_placeholder:'π.χ. Ο φίλος μου ο Χόρχε, οι συνάδελφοί μου, το αφεντικό μου, η Ρεάλ Μαδρίτης',
    children_placeholder:'π.χ. Έμμα, 2 ετών',
    freestyle_placeholder:'π.χ. Ο σκύλος μου που κλέβει πίτσα',

    story_placeholder:'π.χ. Πώς συναντηθήκαμε στο Παρίσι...',

    // Γενικά είδη / στυλ
    'Surprise me':'Εκπλήξτε με',
    'Birthday style':'Στυλ γενεθλίων',
    'Pop-rock':'Ποπ-ροκ',
    'Pop':'Ποπ',
    'Rock':'Ροκ',
    'Jazz':'Τζαζ',
    'Blues':'Μπλουζ',
    'Hip-hop':'Χιπ-χοπ',
    'Folk':'Φολκ',
    'Rap':'Ραπ',
    'Soul':'Σόουλ',
    'Country':'Κάντρι',
    'Electronic':'Ηλεκτρονική',
    'Reggae':'Ρέγκε',

    // Νέο στυλ Χριστουγέννων / Πρωτοχρονιάς
    'Christmas style':'Χριστουγεννιάτικο στυλ',
    'Christmas & New year style':'Στυλ Χριστουγέννων & Πρωτοχρονιάς',

    // Moods / περιστάσεις
    Christmas:'Χριστούγεννα',
    'New Year':'Πρωτοχρονιά',
    'Christmas & New Year':'Χριστούγεννα & Πρωτοχρονιά',
    Happy:'Χαρούμενο',

    Romantic:'Ρομαντικό',
    Emotional:'Συναισθηματικό',
    Funny:'Αστείο',
    Nostalgic:'Νοσταλγικό',
    Flirty:'Φλερτ',
    Epic:'Επικό',
    Cute:'Χαριτωμένο',
    Playful:'Παιχνιδιάρικο',
    Lullaby:'Νανούρισμα',

    // Νέα moods για Χριστουγεννιάτικα / 2025 τραγούδια
    Chill:'Χαλαρό',
    Energetic:'Ενεργητικό',
    'Warm & Sweet':'Ζεστό & γλυκό',
    Upbeat:'Ανεβαστικό',

    more_details:'Πείτε μου περισσότερα (Προαιρετικό)',
    more_placeholder:'Μπορείτε να γράψετε οτιδήποτε θέλετε να συμπεριληφθεί...',

    preferred_vocal:'Προτιμώμενη φωνή',
    male:'Άνδρας',
    female:'Γυναίκα',
    'no_preference':'Χωρίς προτίμηση',

    delivery_speed:'Ταχύτητα παράδοσης',
    select_delivery:'Επιλέξτε χρόνο παράδοσης',

    back:'Πίσω',
    next:'Επόμενο',
    checkout:'Συνέχεια στο Checkout',

    // Per-product “για ποιον είναι το τραγούδι;” (παλιά προϊόντα)
    love_name:'Για ποιον είναι αυτό το τραγούδι αγάπης;',
    birthday_name:'Ποιο είναι το όνομα ή το παρατσούκλι αυτού του ατόμου;',
    family_name:'Ποια μέλη της οικογένειας πρέπει να αναφερθούν;',
    joke_name:'Ποιος ή τι πρέπει να είναι το τραγούδι;',
    children_name:'Όνομα και ηλικία του παιδιού',
    freestyle_name:'Για τι πρέπει να είναι το τραγούδι;',

    birthday_story:'Τι αγαπά ή απολαμβάνει αυτό το άτομο; Αστείες συνήθειες, ιστορίες ή εσωτερικά αστεία;',
    family_story:'Ειδικές αναμνήσεις ή οικογενειακές παραδόσεις;',
    joke_story:'Τι απολαμβάνουν ή κάνουν που είναι αστείο;',
    children_story:'Τι τους κάνει να χαμογελούν',
    freestyle_story:'Ποια είναι η ιστορία ή το μήνυμα που θέλετε στο τραγούδι;',

    children_more:'Πείτε μου περισσότερα για το παιδί',
    other_more:'Πείτε μου περισσότερα (Προαιρετικό)',

    err_dedication:'Παρακαλώ επιλέξτε μία επιλογή.',
    err_name:'Παρακαλώ εισάγετε ένα όνομα.',
    err_language:'Παρακαλώ επιλέξτε μία γλώσσα.',
    err_genre:'Παρακαλώ επιλέξτε ένα είδος.',
    err_mood:'Παρακαλώ επιλέξτε μία διάθεση.',
    err_style:'Παρακαλώ επιλέξτε ένα στυλ.',
    err_age:'Παρακαλώ εισάγετε μία ηλικία.',
    err_story:'Παρακαλώ μοιραστείτε μερικές γραμμές.',
    err_vocal:'Παρακαλώ επιλέξτε μία προτίμηση φωνής.',
    err_delivery:'Παρακαλώ επιλέξτε ταχύτητα παράδοσης.'
  },

    pt:{
    recipient:'Destinatário', story:'História', details:'Detalhes',

    song_price:'🎄Preço festivo',
    price_label:'Preço',
    delivery_label:'Entrega',
    total_label:'Total',
    included:'Incluído',

    express_delivery:'Express (1 hora)',
    fast_delivery:'Rápida (3–5 horas)',
    standard_delivery:'Normal (10–12 horas)',

    choose_type:'Escolha que tipo de canção personalizada quer criar',

    // Etiquetas para os 3 produtos especiais (chips)
    secret_santa:'Amigo Secreto',
    christmas_newyear:'Ano Novo',
    year_2025:'O teu 2025',

    // Categorias genéricas antigas (se alguma vez voltar a usar)
    love:'Amor',
    birthday:'Aniversário',
    family:'Família',
    joke:'Piada',
    children:'Crianças',
    freestyle:'Ideia Livre',

    choose_language:'Escolha a língua da canção',
    select_language:'Selecione a língua',

    name_label:'Nome da pessoa',
    name_placeholder:'ex. Anna, Luca, Mãe, Max (o nosso cão)',

    select_genre:'Selecione o género',
    choose_mood:'Escolha um mood',
    select_mood:'Selecione uma opção',

    // 🔴 NOVAS labels para os 3 produtos especiais (passo 1)
    secret_santa_name_label: 'Para quem é esta canção Secret Santa?',
    secret_santa_name_placeholder: 'ex. A minha colega Sara, o meu amigo João...',

    christmas_newyear_name_label: 'Para quem é esta canção de Ano Novo?',
    christmas_newyear_name_placeholder: 'ex. A minha família… A minha parceira Sara… Os meus filhos… O meu melhor amigo… Os meus colegas...',

    year_2025_name_label: 'Para quem é esta canção de 2025?',
    year_2025_name_placeholder: 'ex. Para mim (o seu nome)… Para a minha parceira Sara… Para a minha família (nomes)…',

    // Bloco Secret Santa (passo 3)
    santa_visibility_label: 'Visibilidade do nome do Secret Santa',
    santa_name_label: 'Nome do remetente (como deve aparecer na canção)',

    keep_name_secret: 'Manter o meu nome em segredo',
    reveal_my_name: 'Revelar o meu nome',
    santa_name_placeholder: 'ex. Do teu Secret Santa, Emma',

    // Novo: “Escolha a ocasião”
    choose_occasion:'Escolha a ocasião',
    occasion:'Ocasião',

    choose_style:'Escolha um estilo de canção',
    select_style:'Selecione o estilo',

    person_age:'Quantos anos faz a pessoa',

    story_label:'Qual é a história ou mensagem que quer na canção?',

    // Exemplos por produto
    love_placeholder:'ex. Como nos conhecemos em Paris',
    birthday_placeholder:'ex. Maria',
    family_placeholder:'ex. Mãe – Ana, Pai – Javier, Filhos – Sofia e Mateo...',
    joke_placeholder:'ex. O meu amigo Jorge, os meus colegas, o meu chefe, o Real Madrid',
    children_placeholder:'ex. Emma, 2 anos',
    freestyle_placeholder:'ex. O meu cão a roubar pizza',

    story_placeholder:'ex. Como nos conhecemos em Paris...',

    // Géneros / estilos
    'Surprise me':'Surpreenda-me',
    'Birthday style':'Estilo de aniversário',
    'Pop-rock':'Pop-rock',
    'Pop':'Pop',
    'Rock':'Rock',
    'Jazz':'Jazz',
    'Blues':'Blues',
    'Hip-hop':'Hip-hop',
    'Folk':'Folk',
    'Rap':'Rap',
    'Soul':'Soul',
    'Country':'Country',
    'Electronic':'Eletrónica',
    'Reggae':'Reggae',

    // Novos estilos de Natal / Ano Novo
    'Christmas style':'Estilo de Natal',
    'Christmas & New year style':'Estilo Natal & Ano Novo',

    // Moods / Ocasiões
    Christmas:'Natal',
    'New Year':'Ano Novo',
    'Christmas & New Year':'Natal & Ano Novo',
    Happy:'Feliz',

    Romantic:'Romântico',
    Emotional:'Emocional',
    Funny:'Engraçado',
    Nostalgic:'Nostálgico',
    Flirty:'Sedutor',
    Epic:'Épico',
    Cute:'Fofo',
    Playful:'Brincalhão',
    Lullaby:'Canção de embalar',

    // Novos moods para canções de Natal / 2025
    Chill:'Calmo',
    Energetic:'Energético',
    'Warm & Sweet':'Quente & doce',
    Upbeat:'Animado',

    more_details:'Conte-me mais (Opcional)',
    more_placeholder:'Pode escrever tudo o que gostaria que fosse incluído...',

    preferred_vocal:'Voz preferida',
    male:'Masculina',
    female:'Feminina',
    'no_preference':'Sem preferência',

    delivery_speed:'Velocidade de entrega',
    select_delivery:'Selecione o tempo de entrega',

    back:'Voltar',
    next:'Seguinte',
    checkout:'Prosseguir para o Checkout',

    // “Para quem é a canção?” para produtos antigos
    love_name:'Para quem é esta canção de amor?',
    birthday_name:'Qual é o nome ou alcunha dessa pessoa?',
    family_name:'Que membros da família devem ser mencionados?',
    joke_name:'Sobre quem ou o quê deve ser a canção?',
    children_name:'Nome e idade da criança',
    freestyle_name:'Sobre o que deve ser a canção?',

    birthday_story:'O que essa pessoa ama ou aprecia? Hábitos engraçados, histórias ou piadas internas?',
    family_story:'Memórias especiais ou tradições de família?',
    joke_story:'O que gostam ou fazem que seja engraçado?',
    children_story:'O que os faz sorrir',
    freestyle_story:'Qual é a história ou mensagem que quer na canção?',

    children_more:'Conte-me mais sobre a criança',
    other_more:'Conte-me mais (Opcional)',

    err_dedication:'Por favor, escolha uma opção.',
    err_name:'Por favor, introduza um nome.',
    err_language:'Por favor, selecione uma língua.',
    err_genre:'Por favor, selecione um género.',
    err_mood:'Por favor, selecione um mood.',
    err_style:'Por favor, selecione um estilo.',
    err_age:'Por favor, introduza uma idade.',
    err_story:'Por favor, escreva algumas linhas.',
    err_vocal:'Por favor, escolha uma preferência de voz.',
    err_delivery:'Por favor, selecione uma velocidade de entrega.'
  }
};

/* Detect current language from URL (handles /pt-pt/, /pt-br/, /pt/) */
function getCurrentLanguage(){
  var path=window.location.pathname||'';
  path=path.toLowerCase();
  if(path.includes('/it/')||path.startsWith('/it')) return 'it';
  if(path.includes('/el/')||path.startsWith('/el')) return 'el';
  if(path.includes('/pt-pt/')||path.includes('/pt-br/')||path.includes('/pt/')||path.startsWith('/pt')) return 'pt';
  return 'en';
}
function t(key,lang){
  if(!lang||lang==='en'||!translations[lang]) return null;
  return translations[lang][key]||null;
}
var currentLang=getCurrentLanguage();

/* Apply translations to static parts + select placeholders */
function applyTranslations(){
  if(currentLang==='en') return;
  var trans=translations[currentLang]; if(!trans) return;

  // Stepper
  var stepperLabels=document.querySelectorAll('.ss-stepper .ss-label');
  if(stepperLabels[0]&&trans.recipient) stepperLabels[0].textContent=trans.recipient;
  if(stepperLabels[1]&&trans.story)     stepperLabels[1].textContent=trans.story;
  if(stepperLabels[2]&&trans.details)   stepperLabels[2].textContent=trans.details;

  // Step 1 title label
  var chooseTypeLabel=document.getElementById('chooseTypeLabel');
  if(chooseTypeLabel&&trans.choose_type) chooseTypeLabel.textContent=trans.choose_type;

// Product chips text (keep emoji)
document.querySelectorAll('#dedicationGrid .ss-chip').forEach(function(chip){
  var value=chip.getAttribute('data-value'); var node=chip.firstChild;
  var label=null;
  if(value==='Secret Santa Gift Song') label=trans.secret_santa;
  if(value==='Christmas & New Year Personalized Song') label=trans.christmas_newyear;
  if(value==='Your 2025 in One Song') label=trans.year_2025;
  if(value==='Love Song') label=trans.love;
  if(value==='Happy Birthday') label=trans.birthday;
  if(value==='Freestyle Song') label=trans.freestyle;
  if(label && node && node.nodeType===3){
    var parts=node.textContent.trim().split(' ');
    var emoji=parts[0]||'';
    node.textContent=(emoji?emoji+' ':'')+label;
  }
});


  // Language field
  var langLabel=document.getElementById('langFieldLabel');
  if(langLabel&&trans.choose_language) langLabel.textContent=trans.choose_language;
  var langSelect=document.getElementById('song_language');
  if(langSelect&&trans.select_language) langSelect.options[0].textContent=trans.select_language;

  // Default name label/placeholder (overwritten by chips later)
  var nameLabel=document.getElementById('nameLabel');
  if(nameLabel&&trans.name_label) nameLabel.textContent=trans.name_label;
  var nameInput=document.getElementById('recipient_name');
  if(nameInput&&trans.name_placeholder) nameInput.placeholder=trans.name_placeholder;

  // Step 2 field labels + placeholders
  var genreLabel=document.getElementById('genreLabel'); if(genreLabel&&trans.select_genre) genreLabel.textContent=trans.select_genre;
  var moodLabel=document.getElementById('moodLabel');   if(moodLabel&&trans.choose_mood)   moodLabel.textContent=trans.choose_mood;
  var moodSelect=document.getElementById('song_mood');  if(moodSelect&&trans.select_mood)  moodSelect.options[0].textContent=trans.select_mood;
  var styleLabel=document.getElementById('styleLabel'); if(styleLabel&&trans.choose_style) styleLabel.textContent=trans.choose_style;
  var styleSelect=document.getElementById('song_style'); if(styleSelect&&trans.select_style) styleSelect.options[0].textContent=trans.select_style;
  var ageLabel=document.getElementById('ageLabel');     if(ageLabel&&trans.person_age)     ageLabel.textContent=trans.person_age;

  // Story + placeholder
  var sLabel=document.getElementById('storyLabel'); if(sLabel&&trans.story_label) sLabel.textContent=trans.story_label;
  var sArea=document.getElementById('song_story');  if(sArea&&trans.story_placeholder) sArea.placeholder=trans.story_placeholder;

  // Step 3 labels + placeholders
  var mLabel=document.getElementById('moreDetailsLabel'); if(mLabel&&trans.other_more) mLabel.textContent=trans.other_more;
  var mArea=document.getElementById('more_details'); if(mArea&&trans.more_placeholder) mArea.placeholder=trans.more_placeholder;
  var vLabel=document.getElementById('vocalLabel'); if(vLabel&&trans.preferred_vocal) vLabel.textContent=trans.preferred_vocal;

 // Secret Santa label & sender name label (step 3)
var santaVisLabel = document.getElementById('santaVisibilityLabel');
if (santaVisLabel && trans.santa_visibility_label) {
  santaVisLabel.textContent = trans.santa_visibility_label;
}

var santaNameLabel = document.getElementById('santaNameLabel');
if (santaNameLabel && trans.santa_name_label) {
  santaNameLabel.textContent = trans.santa_name_label;
}

// NEW → Translate sender name placeholder
var santaNameInput = document.getElementById('santa_name');
if (santaNameInput && trans.santa_name_placeholder) {
  santaNameInput.placeholder = trans.santa_name_placeholder;
}

// Translate the two Santa visibility buttons
document.querySelectorAll('.ss-santa-option span').forEach(function (span) {
  var txt = span.textContent.trim();

  if (/Keep my name secret/i.test(txt) && trans.keep_name_secret) {
    span.textContent = trans.keep_name_secret;
  }

  if (/Reveal my name/i.test(txt) && trans.reveal_my_name) {
    span.textContent = trans.reveal_my_name;
  }
});

  // Vocal buttons
  document.querySelectorAll('.ss-vocal span').forEach(function(span){
    var txt=span.textContent.trim();
    if(/Male/i.test(txt)   && trans.male)          span.textContent=trans.male;
    if(/Female/i.test(txt) && trans.female)        span.textContent=trans.female;
    if(/No preference/i.test(txt) && trans.no_preference) span.textContent=trans.no_preference;
  });

  // Delivery labels/placeholders
  var dLabel=document.getElementById('deliveryLabel'); if(dLabel&&trans.delivery_speed) dLabel.textContent=trans.delivery_speed;
  var dSelect=document.getElementById('delivery_speed'); if(dSelect&&trans.select_delivery) dSelect.options[0].textContent=trans.select_delivery;

  // Buttons
  document.querySelectorAll('.ss-back').forEach(function(b){ if(trans.back) b.textContent=trans.back; });
  document.querySelectorAll('.ss-next').forEach(function(b){ if(trans.next) b.textContent=trans.next; });
  var cBtn=document.getElementById('checkoutBtn'); if(cBtn&&trans.checkout) cBtn.textContent=trans.checkout;

  // Translate selects already populated
  translateSelectOptions('song_genre');
  translateSelectOptions('song_style');
  translateMoodOptions();

  // "Song price"
  var songPriceLabels=document.querySelectorAll('.ss-song-price-label');
  if(songPriceLabels.length && trans.song_price){
    songPriceLabels.forEach(function(label){
      label.textContent=trans.song_price;
    });
  }

  // Price breakdown labels
  var priceLabel=document.querySelector('.ss-trans-price');
  if(priceLabel && trans.price_label) priceLabel.textContent=trans.price_label;
  var deliveryLabel=document.querySelector('.ss-trans-delivery');
  if(deliveryLabel && trans.delivery_label) deliveryLabel.textContent=trans.delivery_label;
  var totalLabel=document.querySelector('.ss-trans-total');
  if(totalLabel && trans.total_label) totalLabel.textContent=trans.total_label;
  var includedLabel=document.querySelector('.ss-trans-included');
  if(includedLabel && trans.included && includedLabel.textContent==='Included') {
    includedLabel.textContent=trans.included;
  }

  // Delivery speed options
  var deliverySelect=document.getElementById('delivery_speed');
  if(deliverySelect && trans){
    var options=deliverySelect.options;
    for(var i=1; i<options.length; i++){
      var opt=options[i];
      var deliveryType=opt.value;
      if(deliveryType==='express' && trans.express_delivery){
        opt.textContent=trans.express_delivery+' | €9.99';
      } else if(deliveryType==='fast' && trans.fast_delivery){
        opt.textContent=trans.fast_delivery+' | €3.99';
      } else if(deliveryType==='standard' && trans.standard_delivery){
        opt.textContent=trans.standard_delivery+' | €0.00';
      }
    }
  }

  if(trans.err_dedication) document.getElementById('errDedication').textContent=trans.err_dedication;
  if(trans.err_name) document.getElementById('errName').textContent=trans.err_name;
  if(trans.err_language) document.getElementById('errLanguage').textContent=trans.err_language;
  if(trans.err_genre) document.getElementById('errGenre').textContent=trans.err_genre;
  if(trans.err_mood) document.getElementById('errMood').textContent=trans.err_mood;
  if(trans.err_style) document.getElementById('errStyle').textContent=trans.err_style;
  if(trans.err_age) document.getElementById('errAge').textContent=trans.err_age;
  if(trans.err_story) document.getElementById('errStory').textContent=trans.err_story;
  if(trans.err_vocal) document.getElementById('errVocal').textContent=trans.err_vocal;
  if(trans.err_delivery) document.getElementById('errDelivery').textContent=trans.err_delivery;
}

/* Translate options helper */
function translateSelectOptions(selectId){
  if(currentLang==='en') return;
  var trans=translations[currentLang]; if(!trans) return;
  var sel=document.getElementById(selectId); if(!sel) return;
  for(var i=1;i<sel.options.length;i++){
    var opt=sel.options[i];
    var val=opt.textContent.trim();
    if(trans[val]) opt.textContent=trans[val];
  }
}
function translateMoodOptions(){
  if(currentLang==='en') return;
  var trans=translations[currentLang]; if(!trans) return;
  var sel=document.getElementById('song_mood'); if(!sel) return;
  for(var i=1;i<sel.options.length;i++){
    var opt=sel.options[i];
    var val=opt.textContent.trim();
    if(trans[val]) opt.textContent=trans[val];
  }
}

/* ===================== ORIGINAL LOGIC ===================== */
var form=document.getElementById('slaysong-wizard');
var steps=Array.from(document.querySelectorAll('.ss-step'));
var stepBtns=Array.from(document.querySelectorAll('.ss-stepper-item'));
var line=document.querySelector('.ss-stepper-line');

var productConfigs = {
  'Secret Santa Gift Song': {
    step1: {
      nameLabel: 'Who is this Secret Santa song for?',
      namePlaceholder: 'e.g. My colleague Sarah, My friend John...'
    },
    step2: {
      genres: ['Christmas style','Pop','Rock','Pop-Rock','Hip-hop','Jazz','Blues','Electronic','Country','Reggae','Folk'],
      moods: ['Christmas','Happy',' Funny','Emotional','Chill','Energetic','Warm & Sweet','Upbeat','Flirty'],
      showMood: true,
      showAge: false,
      showStyle: false,
      storyLabel: "What's the story or message you want in the song?",
      storyPlaceholder: 'e.g. We work together on the same team… She loves coffee and always helps others… He joked during meetings….'
    },
    step3: {
      moreDetailsLabel: 'Tell me more (optional)',
      moreDetailsPlaceholder: 'Anything funny or personal we should add—inside jokes, habits.'
    }
  },

  'Christmas & New Year Personalized Song': {
    step1: {
      // STEP 1: who it's for
      nameLabel: 'Who is this Christmas/New Year song for?',
      namePlaceholder: 'e.g My family… My partner Sarah… My kids… My best friend… My colleagues...'
    },
    step2: {
      // GENRES
      genres: [
        'Christmas & New year style',
        'Pop',
        'Rock',
        'Pop-Rock',
        'Hip-hop',
        'Jazz',
        'Blues',
        'Electronic',
        'Country',
        'Reggae',
        'Folk'
      ],
      // MOODS
      moods: [
      'Christmas',
      'New Year',
      'Christmas & New Year'
    ],
      showMood: true,
      showAge: false,
      showStyle: false,
      // STORY QUESTION
      storyLabel: 'What’s the story or message you want in the song?',
      storyPlaceholder: 'e.g. A warm Christmas message… our year together… holiday wishes… special moments… gratitude…'
    },
    step3: {
      // TELL ME MORE
      moreDetailsLabel: 'Tell me more',
      moreDetailsPlaceholder: 'Traditions, funny moments, family details, what they love about New Year—anything personal to include.'
    }
  },

  'Your 2025 in One Song': {
    step1: {
      nameLabel: 'Who is this 2025 song for?',
      namePlaceholder: 'e.g. For myself (your name)… For my partner Sarah… For my family (names)…'
    },
    step2: {
      genres: ['Christmas & New year style','Pop','Rock','Hip-hop','Electronic','Folk'],
      moods: ['Christmas','Happy','Emotional','Funny','Chill','Warm & Sweet','Flirty'],
      showMood: true,
      showAge: false,
      showStyle: false,
      storyLabel: "What's the story or message you want in the song?",
      storyPlaceholder: ' e.g. For myself (your name)… For my partner Sarah… For my family (names)…'
    },
    step3: {
      moreDetailsLabel: 'Tell me more (optional)',
      moreDetailsPlaceholder: ' e.g. Tell us anything you want included — moments, memories, names'
    }
  },

   'Love Song': {
    step1: {
    nameLabel: 'Who is this love song for?',
    namePlaceholder: 'e.g. My wife Marta, My boyfriend Luca...'
  },
  step2: {
    genres: ['Surprise me','Pop-rock','Pop','Rock','Jazz','Blues','Hip-hop','Folk'],
    moods: ['Romantic','Emotional','Funny','Nostalgic','Flirty'],
    showMood: true,
    showAge: false,
    showStyle: false,
    storyLabel: "What's the story or message you want in the song?",
    storyPlaceholder: 'e.g. How we met in Paris...'
  },
  step3: {
    moreDetailsLabel: 'Tell me more (optional)',
    moreDetailsPlaceholder: 'You can write anything you\'d like to be included...'
  }
},

'Happy Birthday': {
  step1: {
    nameLabel: "What's this person's Name or Nickname",
    namePlaceholder: 'e.g. Maria'
  },
  step2: {
    genres: ['Birthday style','Pop-rock','Pop','Rock','Jazz','Blues','Hip-hop','Folk'],
    moods: [],
    showMood: false,
    showAge: true,
    showStyle: false,
    storyLabel: 'What does this person love or enjoy? Funny habits, stories, or inside jokes?',
    storyPlaceholder: 'e.g. Loves wine, dancing, traveling. Sings in the shower...'
  },
  step3: {
    moreDetailsLabel: 'Tell me more (optional)',
    moreDetailsPlaceholder: 'You can write anything you\'d like to be included...'
  }
},

'Freestyle Song': {
  step1: {
    nameLabel: 'What should the song be about?',
    namePlaceholder: 'e.g. A birthday song for my friend, a rap about my dog stealing pizza, a romantic melody for my long-distance girlfriend...'
  },
  step2: {
    genres: ['Surprise me','Pop','Rock','Pop-Rock','Hip-hop','Jazz','Electronic','Reggae','Folk'],
    moods: ['Surprise me','Funny','Emotional','Epic','Cute'],
    showMood: true,
    showAge: false,
    showStyle: false,
    storyLabel: "What's the story or message you want in the song?",
    storyPlaceholder: 'e.g. How we met in Paris...'
  },
  step3: {
    moreDetailsLabel: 'Tell me more (optional)',
    moreDetailsPlaceholder: 'You can write anything you\'d like to be included...'
  }
}

};

var infoContent={
  love:'A romantic song perfect for expressing your feelings to your partner, soulmate, or loved one.',
  birthday:'A personalized birthday song celebrating someone special with their unique story and personality.',
  family:'A heartwarming song about family bonds, memories, and the people who matter most.',
  joke:'A funny, lighthearted song that pokes fun in a playful way - perfect for friends and colleagues.',
  children:'A fun, age-appropriate song designed to make kids smile with their favorite things.',
  freestyle:'Complete creative freedom - tell us your idea and we\'ll create a unique song just for you.'
};

var chips=document.querySelectorAll('#dedicationGrid .ss-chip');
var dedInput=document.getElementById('dedication_select');
var productTypeInput=document.getElementById('ssProductType');
var infoBox=document.getElementById('infoBox');

chips.forEach(function(btn){
  btn.setAttribute('aria-pressed','false');
  btn.addEventListener('click',function(e){
    if(e.target.classList.contains('ss-info'))return;
    chips.forEach(function(b){b.classList.remove('active');b.setAttribute('aria-pressed','false')});
    this.classList.add('active'); this.setAttribute('aria-pressed','true');
    var value=this.getAttribute('data-value');
    
    document.getElementById('dedication_select').value = value;
    document.getElementById('ssProductType').value = value;
    
    updateFieldsForProduct(value);
    validateStep1(false);
  });
});

document.querySelectorAll('.ss-info').forEach(function(info){
  info.addEventListener('click',function(e){
    e.stopPropagation();
    var type=this.getAttribute('data-type');
    infoBox.textContent=infoContent[type];
    infoBox.hidden=false;
    setTimeout(function(){infoBox.hidden=true},5000);
  });
});

/* ===== UPDATE FIELDS (with translations & per-type placeholders) ===== */
function updateFieldsForProduct(productType){
  var config=productConfigs[productType]; if(!config) return;

  var trans=currentLang!=='en'?translations[currentLang]:null;

  // Base EN labels/placeholders
  var nameLabel             = config.step1.nameLabel;
  var namePlaceholder       = config.step1.namePlaceholder;
  var storyLabel            = config.step2.storyLabel;
  var storyPlaceholder      = config.step2.storyPlaceholder;
  var moreDetailsLabel      = config.step3.moreDetailsLabel;
  var moreDetailsPlaceholder= config.step3.moreDetailsPlaceholder;

    if (trans) {
    // Per-type labels (vecchi + nuovi prodotti)
    if (productType === 'Love Song'        && trans.love_name)        nameLabel = trans.love_name;
    else if (productType === 'Happy Birthday'   && trans.birthday_name)  nameLabel = trans.birthday_name;
    else if (productType === 'Family Song'      && trans.family_name)    nameLabel = trans.family_name;
    else if (productType === 'Joke Song'        && trans.joke_name)      nameLabel = trans.joke_name;
    else if (productType === 'Children Song'    && trans.children_name)  nameLabel = trans.children_name;
    else if (productType === 'Freestyle Song'   && trans.freestyle_name) nameLabel = trans.freestyle_name;

    // 🔴 NUOVI PRODOTTI
    else if (productType === 'Secret Santa Gift Song' && trans.secret_santa_name_label)
      nameLabel = trans.secret_santa_name_label;
    else if (productType === 'Christmas & New Year Personalized Song' && trans.christmas_newyear_name_label)
      nameLabel = trans.christmas_newyear_name_label;
    else if (productType === 'Your 2025 in One Song' && trans.year_2025_name_label)
      nameLabel = trans.year_2025_name_label;

    // Fallback generico
    else if (trans.name_label)
      nameLabel = trans.name_label;


    if(productType==='Happy Birthday'    && trans.birthday_story)   storyLabel=trans.birthday_story;
    else if(productType==='Family Song'  && trans.family_story)     storyLabel=trans.family_story;
    else if(productType==='Joke Song'    && trans.joke_story)       storyLabel=trans.joke_story;
    else if(productType==='Children Song'&& trans.children_story)   storyLabel=trans.children_story;
    else if(productType==='Freestyle Song'&& trans.freestyle_story) storyLabel=trans.freestyle_story;
    else if(trans.story_label) storyLabel=trans.story_label;

    if(productType==='Children Song' && trans.children_more) moreDetailsLabel=trans.children_more;
    else if(trans.other_more)        moreDetailsLabel=trans.other_more;

        // Per-type example placeholders for Step 1
    if (productType === 'Love Song'        && trans.love_placeholder)
      namePlaceholder = trans.love_placeholder;
    else if (productType === 'Happy Birthday' && trans.birthday_placeholder)
      namePlaceholder = trans.birthday_placeholder;
    else if (productType === 'Family Song' && trans.family_placeholder)
      namePlaceholder = trans.family_placeholder;
    else if (productType === 'Joke Song'   && trans.joke_placeholder)
      namePlaceholder = trans.joke_placeholder;
    else if (productType === 'Children Song' && trans.children_placeholder)
      namePlaceholder = trans.children_placeholder;
    else if (productType === 'Freestyle Song' && trans.freestyle_placeholder)
      namePlaceholder = trans.freestyle_placeholder;

    // 🔴 NUOVI PRODOTTI
    else if (productType === 'Secret Santa Gift Song' && trans.secret_santa_name_placeholder)
      namePlaceholder = trans.secret_santa_name_placeholder;
    else if (productType === 'Christmas & New Year Personalized Song' && trans.christmas_newyear_name_placeholder)
      namePlaceholder = trans.christmas_newyear_name_placeholder;
    else if (productType === 'Your 2025 in One Song' && trans.year_2025_name_placeholder)
      namePlaceholder = trans.year_2025_name_placeholder;

    // Fallback generico
    else if (trans.name_placeholder)
      namePlaceholder = trans.name_placeholder;


    // Optional generic placeholders
    if(trans.story_placeholder) storyPlaceholder = trans.story_placeholder;
    if(trans.more_placeholder)  moreDetailsPlaceholder = trans.more_placeholder;
  }

  document.getElementById('nameLabel').textContent=nameLabel;
  document.getElementById('recipient_name').placeholder=namePlaceholder;

  var genreSelect=document.getElementById('song_genre');
  var moodSelect=document.getElementById('song_mood');
  var genreField=document.getElementById('genreField');
  var moodField=document.getElementById('moodField');
  var styleField=document.getElementById('styleField');
  var ageField=document.getElementById('ageField');

  // Style vs Genre
  if(config.step2.showStyle){
    genreField.hidden=true; styleField.hidden=false;
    var styleLabel=document.getElementById('styleLabel');
    if(trans && trans.choose_style) styleLabel.textContent=trans.choose_style;
    var styleSel=document.getElementById('song_style');
    styleSel.innerHTML='<option value="" disabled selected>'+(trans&&trans.select_style?trans.select_style:'Select style')+'</option><option>Playful</option><option>Lullaby</option>';
    translateSelectOptions('song_style');
  }else{
    genreField.hidden=false; styleField.hidden=true;
    genreSelect.innerHTML='<option value="" disabled selected>'+(trans&&trans.select_genre?trans.select_genre:'Select genre')+'</option>';
    config.step2.genres.forEach(function(g){
      var opt=document.createElement('option'); opt.textContent=g; genreSelect.appendChild(opt);
    });
    translateSelectOptions('song_genre');
  }

  // Mood / Occasion
  if (config.step2.showMood) {
    moodField.hidden = false;
    moodSelect.innerHTML =
      '<option value="" disabled selected>' +
      (trans && trans.select_mood ? trans.select_mood : 'Select option') +
      '</option>';

    config.step2.moods.forEach(function (m) {
      var opt = document.createElement('option');
      opt.textContent = m;
      moodSelect.appendChild(opt);
    });

    translateMoodOptions();

    var moodLabelEl = document.getElementById('moodLabel');

        var moodLabelEl = document.getElementById('moodLabel');

    if (productType === 'Christmas & New Year Personalized Song') {
      // Usa la traduzione se esiste, altrimenti fallback in inglese
      if (trans && trans.choose_occasion) {
        moodLabelEl.textContent = trans.choose_occasion + ':';
      } else {
        moodLabelEl.textContent = 'Choose the occasion:';
      }
    } else if (trans && trans.choose_mood) {
      // Altri prodotti: "Scegli un mood" ecc.
      moodLabelEl.textContent = trans.choose_mood;
    }

    // For English + other products without translation,
    // the HTML default "Choose a mood" stays as-is.
  } else {
    moodField.hidden = true;
  }


  // Age
  ageField.hidden=!config.step2.showAge;
  if(trans && trans.person_age) document.getElementById('ageLabel').textContent=trans.person_age;

  // Story + more
  document.getElementById('storyLabel').textContent=storyLabel;
  document.getElementById('song_story').placeholder=storyPlaceholder;

  document.getElementById('moreDetailsLabel').textContent=moreDetailsLabel;
  document.getElementById('more_details').placeholder=moreDetailsPlaceholder;

  // SECRET SANTA visibility block show/hide
  var santaField = document.getElementById('santaVisibilityField');
  if (santaField) {
    var santaChoiceHidden = document.getElementById('santaVisibilityChoice');
    var santaNameInput = document.getElementById('santa_name');
    var santaNameField = document.getElementById('santaNameField');
    var errSantaVisibility = document.getElementById('errSantaVisibility');
    var errSantaName = document.getElementById('errSantaName');

    if (productType === 'Secret Santa Gift Song') {
      santaField.hidden = false;
    } else {
      santaField.hidden = true;
      if (santaChoiceHidden) santaChoiceHidden.value = '';
      if (santaNameInput) {
        santaNameInput.value = '';
        santaNameInput.classList.remove('has-error');
      }
      if (santaNameField) santaNameField.hidden = true;
      if (errSantaVisibility) errSantaVisibility.hidden = true;
      if (errSantaName) errSantaName.hidden = true;

      var santaButtonsReset = document.querySelectorAll('.ss-santa-option');
      santaButtonsReset.forEach(function (btn) {
        btn.setAttribute('aria-pressed', 'false');
        btn.classList.remove('has-error');
      });
    }
  }
}

/* VOCAL TOGGLES */
var vocalBtns=document.querySelectorAll('.ss-toggle.ss-vocal');
var vocalHidden=document.getElementById('ssVocalValue');
var errVocal=document.getElementById('errVocal');
vocalBtns.forEach(function(btn){
  btn.addEventListener('click',function(){
    vocalBtns.forEach(function(b){b.setAttribute('aria-pressed','false')});
    this.setAttribute('aria-pressed','true');
    vocalHidden.value=this.getAttribute('data-value');
    errVocal.hidden=true;
    validateStep3(false);
  });
  btn.setAttribute('aria-pressed','false');
  btn.setAttribute('tabindex','0');
  btn.addEventListener('keydown',function(e){
    if(e.key==='Enter'||e.key===' '){e.preventDefault();this.click();}
  });
});

/* SECRET SANTA NAME VISIBILITY TOGGLES */
var santaButtons = document.querySelectorAll('.ss-santa-option');
var santaChoiceHidden = document.getElementById('santaVisibilityChoice');
var santaNameField = document.getElementById('santaNameField');
var santaNameInput = document.getElementById('santa_name');
var errSantaVisibility = document.getElementById('errSantaVisibility');
var errSantaName = document.getElementById('errSantaName');

santaButtons.forEach(function (btn) {
  btn.addEventListener('click', function () {
    var productType = document.getElementById('ssProductType').value || document.getElementById('dedication_select').value;
    if (productType !== 'Secret Santa Gift Song') return;

    santaButtons.forEach(function (b) {
      b.setAttribute('aria-pressed', 'false');
      b.classList.remove('has-error');
    });

    this.setAttribute('aria-pressed', 'true');
    if (santaChoiceHidden) santaChoiceHidden.value = this.getAttribute('data-value');
    if (errSantaVisibility) errSantaVisibility.hidden = true;

    if (santaChoiceHidden && santaChoiceHidden.value === 'Reveal my name') {
      if (santaNameField) santaNameField.hidden = false;
    } else {
      if (santaNameField) santaNameField.hidden = true;
      if (santaNameInput) {
        santaNameInput.value = '';
        santaNameInput.classList.remove('has-error');
      }
      if (errSantaName) errSantaName.hidden = true;
    }

    validateStep3(false);
  });

  btn.setAttribute('aria-pressed', 'false');
  btn.setAttribute('tabindex', '0');
  btn.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      this.click();
    }
  });
});

/* STEPS */
function showStep(n){
  steps.forEach(function(s){s.classList.remove('is-active')});
  steps[n-1].classList.add('is-active');
  stepBtns.forEach(function(b,i){
    b.classList.remove('is-active','is-done');
    b.disabled=i>n-1&&!(i<n-1);
    if(i<n-1){b.classList.add('is-done');b.disabled=false}
    if(i===n-1){b.classList.add('is-active');b.disabled=false;b.setAttribute('aria-current','step')}
    else{b.removeAttribute('aria-current')}
  });
  
  var trans=currentLang!=='en'?translations[currentLang]:null;
  if(trans && trans.song_price){
    var labels=document.querySelectorAll('.ss-song-price-label');
    labels.forEach(function(label){
      label.textContent=trans.song_price;
    });
  }
  
  if(n===3 && trans){
    var deliverySelect=document.getElementById('delivery_speed');
    if(deliverySelect){
      var options=deliverySelect.options;
      for(var i=1; i<options.length; i++){
        var opt=options[i];
        var deliveryType=opt.value;
        if(deliveryType==='express' && trans.express_delivery){
          opt.textContent=trans.express_delivery+' | €9.99';
        } else if(deliveryType==='fast' && trans.fast_delivery){
          opt.textContent=trans.fast_delivery+' | €3.99';
        } else if(deliveryType==='standard' && trans.standard_delivery){
          opt.textContent=trans.standard_delivery+' | €0.00';
        }
      }
    }
  }
}

/* VALIDATION */
function validateStep1(showErrors){
  var ok=true;
  var ded=dedInput.value.trim();
  var name=document.getElementById('recipient_name').value.trim();
  var nameInput=document.getElementById('recipient_name');
  var lang=document.getElementById('song_language').value;
  var langSelect=document.getElementById('song_language');
  
  if(!ded){
    ok=false;
    if(showErrors){
      document.getElementById('errDedication').hidden=false;
      document.querySelectorAll('#dedicationGrid .ss-chip').forEach(function(chip){
        chip.classList.add('has-error');
      });
    }
  } else {
    document.getElementById('errDedication').hidden=true;
    document.querySelectorAll('#dedicationGrid .ss-chip').forEach(function(chip){
      chip.classList.remove('has-error');
    });
  }
  
  if(!name){
    ok=false;
    if(showErrors){
      document.getElementById('errName').hidden=false;
      nameInput.classList.add('has-error');
    }
  } else {
    document.getElementById('errName').hidden=true;
    nameInput.classList.remove('has-error');
  }
  
  if(!lang){
    ok=false;
    if(showErrors){
      document.getElementById('errLanguage').hidden=false;
      langSelect.classList.add('has-error');
    }
  } else {
    document.getElementById('errLanguage').hidden=true;
    langSelect.classList.remove('has-error');
  }
  
  return ok;
}

function validateStep2(showErrors){
  var productType=productTypeInput.value;
  var config=productConfigs[productType]; if(!config) return false;
  var ok=true;
  var genre=document.getElementById('song_genre').value;
  var genreSelect=document.getElementById('song_genre');
  var mood=document.getElementById('song_mood').value;
  var moodSelect=document.getElementById('song_mood');
  var style=document.getElementById('song_style').value;
  var styleSelect=document.getElementById('song_style');
  var age=document.getElementById('person_age').value.trim();
  var ageInput=document.getElementById('person_age');
  var story=document.getElementById('song_story').value.trim();
  var storyArea=document.getElementById('song_story');

  if(config.step2.showStyle){
    if(!style){
      ok=false;
      if(showErrors){
        document.getElementById('errStyle').hidden=false;
        styleSelect.classList.add('has-error');
      }
    } else {
      document.getElementById('errStyle').hidden=true;
      styleSelect.classList.remove('has-error');
    }
  } else {
    if(!genre){
      ok=false;
      if(showErrors){
        document.getElementById('errGenre').hidden=false;
        genreSelect.classList.add('has-error');
      }
    } else {
      document.getElementById('errGenre').hidden=true;
      genreSelect.classList.remove('has-error');
    }
  }

  if(config.step2.showMood){
    if(!mood){
      ok=false;
      if(showErrors){
        document.getElementById('errMood').hidden=false;
        moodSelect.classList.add('has-error');
      }
    } else {
      document.getElementById('errMood').hidden=true;
      moodSelect.classList.remove('has-error');
    }
  }
  
  if(config.step2.showAge){
    if(!age){
      ok=false;
      if(showErrors){
        document.getElementById('errAge').hidden=false;
        ageInput.classList.add('has-error');
      }
    } else {
      document.getElementById('errAge').hidden=true;
      ageInput.classList.remove('has-error');
    }
  }
  
  if(!story){
    ok=false;
    if(showErrors){
      document.getElementById('errStory').hidden=false;
      storyArea.classList.add('has-error');
    }
  } else {
    document.getElementById('errStory').hidden=true;
    storyArea.classList.remove('has-error');
  }

  return ok;
}

function validateStep3(showErrors){
  var delivery=document.getElementById('delivery_speed').value;
  var deliverySelect=document.getElementById('delivery_speed');
  var vocal=vocalHidden.value;
  var ok=true;
  var productType = document.getElementById('ssProductType').value || document.getElementById('dedication_select').value;
  
  if(!delivery){
    ok=false;
    if(showErrors){
      document.getElementById('errDelivery').hidden=false;
      deliverySelect.classList.add('has-error');
    }
  } else {
    document.getElementById('errDelivery').hidden=true;
    deliverySelect.classList.remove('has-error');
  }
  
  if(!vocal){
    ok=false;
    if(showErrors){
      errVocal.hidden=false;
      document.querySelectorAll('.ss-vocal').forEach(function(btn){
        btn.classList.add('has-error');
      });
    }
  } else {
    errVocal.hidden=true;
    document.querySelectorAll('.ss-vocal').forEach(function(btn){
      btn.classList.remove('has-error');
    });
  }

  // SECRET SANTA extra validation
  if (productType === 'Secret Santa Gift Song') {
    var santaChoiceVal = santaChoiceHidden ? santaChoiceHidden.value : '';
    var santaBtns = document.querySelectorAll('.ss-santa-option');

    if (!santaChoiceVal) {
      ok = false;
      if (showErrors && errSantaVisibility) {
        errSantaVisibility.hidden = false;
        santaBtns.forEach(function (btn) {
          btn.classList.add('has-error');
        });
      }
    } else {
      if (errSantaVisibility) errSantaVisibility.hidden = true;
      santaBtns.forEach(function (btn) {
        btn.classList.remove('has-error');
      });
    }

    if (santaChoiceVal === 'Reveal my name') {
      var val = santaNameInput ? (santaNameInput.value || '').trim() : '';
      if (!val) {
        ok = false;
        if (showErrors && errSantaName && santaNameInput) {
          errSantaName.hidden = false;
          santaNameInput.classList.add('has-error');
        }
      } else {
        if (errSantaName) errSantaName.hidden = true;
        if (santaNameInput) santaNameInput.classList.remove('has-error');
      }
    } else {
      if (errSantaName) errSantaName.hidden = true;
      if (santaNameInput) santaNameInput.classList.remove('has-error');
    }
  }
  
  return ok;
}

/* Update price breakdown based on delivery speed */
function updatePriceBreakdown(){
  var deliverySelect=document.getElementById('delivery_speed');
  var selectedOption=deliverySelect.options[deliverySelect.selectedIndex];
  var deliveryPrice=selectedOption.getAttribute('data-price');
  
  var deliveryPriceEl=document.querySelector('.ss-delivery-price');
  var totalPriceEl=document.querySelector('.ss-total-price');
  
  if(!deliveryPriceEl || !totalPriceEl) return;
  
  var basePrice=14.99;  // New base price
  var deliveryFee=0;
  var totalPrice=basePrice;
  
  if(deliveryPrice){
    deliveryFee=parseFloat(deliveryPrice);
    totalPrice=basePrice+deliveryFee;
  }
  
  var trans=currentLang!=='en'?translations[currentLang]:null;
  var includedText=trans&&trans.included?trans.included:'Included';
  
  if(deliveryFee===0 || !deliveryPrice){
    deliveryPriceEl.textContent=includedText;
    deliveryPriceEl.classList.remove('has-fee');
  }else{
    deliveryPriceEl.textContent='+ €'+deliveryFee.toFixed(2).replace('.',',');
    deliveryPriceEl.classList.add('has-fee');
  }

  totalPriceEl.textContent='€'+totalPrice.toFixed(2).replace('.',',');
}
/* Live validate - hide errors on input */
['change','input'].forEach(function(ev){
  document.getElementById('dedication_select').addEventListener(ev,function(){
    document.getElementById('errDedication').hidden=true;
    document.querySelectorAll('#dedicationGrid .ss-chip').forEach(function(chip){
      chip.classList.remove('has-error');
    });
  });
  document.getElementById('recipient_name').addEventListener(ev,function(){
    document.getElementById('errName').hidden=true;
    this.classList.remove('has-error');
  });
  document.getElementById('song_language').addEventListener(ev,function(){
    document.getElementById('errLanguage').hidden=true;
    this.classList.remove('has-error');
  });

  document.getElementById('song_genre').addEventListener(ev,function(){validateStep2(false)});
  document.getElementById('song_mood').addEventListener(ev,function(){validateStep2(false)});
  document.getElementById('song_style').addEventListener(ev,function(){validateStep2(false)});
  document.getElementById('person_age').addEventListener(ev,function(){validateStep2(false)});
  document.getElementById('song_story').addEventListener(ev,function(){validateStep2(false)});
  document.getElementById('delivery_speed').addEventListener(ev,function(){
    document.getElementById('errDelivery').hidden=true;
    this.classList.remove('has-error');
    updatePriceBreakdown();
  });

  // SECRET SANTA name live validation
  if (document.getElementById('santa_name')) {
    document.getElementById('santa_name').addEventListener(ev, function () {
      if (errSantaName) errSantaName.hidden = true;
      this.classList.remove('has-error');
      validateStep3(false);
    });
  }
});

/* Reset checkout button on bfcache */
function resetCheckoutButton(){
  var btn=document.getElementById('checkoutBtn');
  if(btn){btn.disabled=false;btn.textContent=(t('checkout',currentLang)||'Proceed to Checkout');}
}
window.addEventListener('pageshow',resetCheckoutButton);

/* Nav buttons */
document.getElementById('toStep2').addEventListener('click',function(){ if(validateStep1(true)) showStep(2) });
document.querySelector('[data-back="1"]').addEventListener('click',function(){ showStep(1) });
document.getElementById('toStep3').addEventListener('click',function(){ if(validateStep2(true)) showStep(3) });
document.querySelector('[data-back="2"]').addEventListener('click',function(){ showStep(2) });

form.addEventListener('submit',function(e){e.preventDefault()});

/* ===== Checkout handler (FIXED) ===== */
var checkoutBtn=document.getElementById('checkoutBtn');
checkoutBtn.addEventListener('click',function(){
  if(!validateStep3(true)) return;

  var btn=this;
  btn.disabled=true;
  var originalText=btn.textContent;
  btn.textContent='Processing…';

  // 1) Get product type first
  var productType=document.getElementById('ssProductType').value || document.getElementById('dedication_select').value;

  if(!productType){
    alert('Please select a product type first');
    btn.disabled=false;
    btn.textContent=originalText;
    return;
  }

  var config=productConfigs[productType];
  if(!config){
    alert('Invalid product type selected. Please refresh and try again.');
    btn.disabled=false;
    btn.textContent=originalText;
    return;
  }

  // 2) Get delivery value (express / fast / standard)
  var deliverySelect=document.getElementById('delivery_speed');
  var deliveryType=deliverySelect.value;

  // 3) Map each product to its delivery speed variants
 var productVariantMap = {
  'Secret Santa Gift Song': {
    'express': 46961851465958,
    'fast': 46961851433190,
    'standard': 46961851400422
  },
  'Christmas & New Year Personalized Song': {
    'express': 47001391759590,
    'fast': 47001391726822,
    'standard': 47001391694054
  },
  'Your 2025 in One Song': {
    'express': 47001465651430,
    'fast': 47001465618662,
    'standard': 47001465585894
  },
  'Love Song': {
    'express': 47023025651942,
    'fast': 47023025619174,
    'standard': 47023025586406
  },
  'Happy Birthday': {
    'express': 47023025651942,
    'fast': 47023025619174,
    'standard': 47023025586406
  },
  'Freestyle Song': {
    'express': 47023025651942,
    'fast': 47023025619174,
    'standard': 47023025586406
  }
};


  var selectedVariantId = (productVariantMap[productType] || {})[deliveryType] || null;

  if(!selectedVariantId){
    alert('Could not determine the correct variant for the selected delivery speed. Please refresh and try again.');
    btn.disabled=false;
    btn.textContent=originalText;
    return;
  }

  // Language detection
  var siteCode=(window.Shopify&&Shopify.locale)||(document.documentElement.lang||'').split('-')[0]||'en';
  siteCode=siteCode.toLowerCase();
  if(siteCode.startsWith('pt')) siteCode='pt';

  var siteLangMap={en:'en',es:'es',el:'el',it:'it',fr:'fr',pt:'pt-PT',de:'de'};
  var siteLangName=siteLangMap[siteCode]||'English';

  var properties = {};

  // 1) Song language
  var langValue = document.getElementById('song_language').value;
  if (langValue) {
    properties['Song language'] = langValue;
  }

  // 2) Genre / Style
  if (config.step2.showStyle) {
    var style = document.getElementById('song_style').value;
    if (style) properties['Song style'] = style;
  } else {
    var genre = document.getElementById('song_genre').value;
    if (genre) properties['Genre'] = genre;
  }

  // 3) Mood / Occasion (depends on product)
  if (config.step2.showMood) {
    var mood = document.getElementById('song_mood').value;
    if (mood) {
      // For Christmas & New Year product, call it "Occasion"
      var moodKey = (productType === 'Christmas & New Year Personalized Song')
        ? 'Occasion'
        : 'Song mood';

      properties[moodKey] = mood;
    }
  }

  // 4) Recipient name (uses your existing label, e.g. "Who is this Secret Santa song for?")
  var nameLabel = config.step1.nameLabel;
  var recipientValue = document.getElementById('recipient_name').value;
  if (recipientValue) {
    properties[nameLabel] = recipientValue;
  }

  // 4.5) Age (for Birthday product)
if (config.step2.showAge) {
  var ageValue = document.getElementById('person_age').value;
  if (ageValue) {
    properties['How old is the person turning?'] = ageValue;
  }
}


  // 5) Story label (e.g. "What's the story or message you want in the song?")
  var storyLabel = config.step2.storyLabel;
  var storyValue = document.getElementById('song_story').value;
  if (storyValue) {
    properties[storyLabel] = storyValue;
  }

  // 6) "Tell me more:" (no "(optional)" in checkout)
  var moreDetails = document.getElementById('more_details').value;
  if (moreDetails) {
    var moreLabel = (config.step3.moreDetailsLabel || 'Tell me more').replace(' (optional)', '');
    moreLabel = moreLabel.replace(/:$/, '') + ':'; // ensure it ends with ":"
    properties[moreLabel] = moreDetails;
  }

  // 7) Secret Santa extra properties BEFORE vocal gender
  if (productType === 'Secret Santa Gift Song') {
    var santaChoiceVal = santaChoiceHidden ? santaChoiceHidden.value : '';
    var santaNameVal = santaNameInput ? (santaNameInput.value || '').trim() : '';

    if (santaChoiceVal) {
      // This will appear as:
      // Secret Santa name visibility: Keep my name secret / Reveal my name
      properties['Secret Santa name visibility'] = santaChoiceVal;
    }

    if (santaChoiceVal === 'Reveal my name' && santaNameVal) {
      // This will appear as:
      // Sender Name: From your secret santa, Emma
      properties['Sender Name'] = santaNameVal;
    }
  }

// 8) Vocal gender (comes AFTER Secret Santa fields)
var vocalValue = document.getElementById('ssVocalValue').value;

if (vocalValue) {
  // Remove emoji + extra spaces (handles 👨🏻 Male / 👩🏼 Female)
  var cleanVocal = vocalValue.replace(/^[^\w]+/g, '').trim();
  // "👨🏻 Male"   -> "Male"
  // "👩🏼 Female" -> "Female"
  // "No preference" stays "No preference"

  // Business rule: No preference defaults to Female
  if (cleanVocal === 'No preference') {
    cleanVocal = 'Female';
  }

  // Only ever send Male or Female to checkout
  if (cleanVocal === 'Male' || cleanVocal === 'Female') {
    properties['Vocal gender'] = cleanVocal;
  }
}

  // 9) Language Used (kept as is)
  properties['Language Used'] = siteLangName;


  fetch('/cart/clear.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'}})
  .then(function(){
    return fetch('/cart/add.js',{
      method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({id:selectedVariantId,quantity:1,properties:properties})
    });
  })
  .then(async function(res){
    var data=await res.json().catch(function(){return{}});
    if(!res.ok){
      var msg=(data&&data.description)||(data&&data.message)||'Something went wrong. Please try again.';
      throw new Error(msg);
    }
    return data;
  })
  .then(function(){window.location.href='/checkout'})
  .catch(function(err){
    console.error(err);
    alert(err.message||'Something went wrong. Please try again.');
    btn.disabled=false; btn.textContent=originalText;
  });
});

/* INIT */
showStep(1);
applyTranslations();
updatePriceBreakdown();

})();